import { Spin } from "antd";
import type { ReactNode } from "react";

export interface ContentSpinProps {
  spinning: boolean;
  tip?: string;
  children: ReactNode;
}

const ContentSpin = ({ spinning, tip = "Загрузка данных…", children }: ContentSpinProps) => (
  <Spin spinning={spinning} tip={tip} size="large">
    {children}
  </Spin>
);

export default ContentSpin;
